import defaultSettings from '@/settings'

const {showSettings, tagsView, fixedHeader, sidebarLogo, title, logo,resourcesPath} = defaultSettings

const state = {
    theme: null,
    showSettings: showSettings,
    tagsView: tagsView,
    fixedHeader: fixedHeader,
    sidebarLogo: sidebarLogo,
    title: title,
    logo: logo,
    resourcesPath
}

const mutations = {
    CHANGE_SETTING: (state, {key, value}) => {
        if (state.hasOwnProperty(key)) {
            state[key] = value
        }
    }
}

const actions = {
    changeSetting({commit}, data) {
        commit('CHANGE_SETTING', data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

